<template>
    <div class="list">
        <van-list v-model="loading" :finished="finished" finished-text="已到底部" @load="onLoad">
            <div class="list-box" v-for="(item,index) in list" :key="index" >
                <div class="list-box-first" @click="goCourse(item)">
                    <div class="list-box-first-img">
                        <img :src="item.cover_img" alt="">
                    </div>
                </div>
                <div class="list-box-second">
                    <div class="list-box-second-wrap" v-for="(i,ind) in item.items" :key="ind" @click="goCourseDetail(i,item)">
                        <div class="list-box-second-wrap-item">
                            <div class="list-box-second-wrap-item-img">
                                <img :src="i.cover_img" alt="">
                            </div>
                            <div class="list-box-second-wrap-item-title">
                                <span>{{ i.title }}</span>
                            </div>
                            <div class="list-box-second-wrap-item-desc">
                                <span>{{ i.view_count }}人观看</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </van-list>
        <Back bottom="14vh"></Back>
    </div>
</template>

<script>
import Interface from "@/util/interface"
import Back from '@/components/back'
export default {
    name: "list",
    components :{
        Back,
    },
    data() {
        return {
            list: [],
            loading: false,
            finished: false,
            page: 0,
        }
    },
    methods: {
        onLoad() {
            this.page++
            let params = {
                page: this.page,
                pageSize: 10
            }
            Interface.getData('get', Interface.v4.course_list, params).then((res) => {
                if (res.code == 0) {
                    if (res.data.list && res.data.list.length) {
                        this.list.push(...res.data.list)
                    }
                    this.loading = false
                    if (this.page >= res.data.total_page) {
                        this.finished = true
                    }
                }
            })
        },
        // 课程专栏跳转
        goCourse(item) {
            if(item.source_type == 4){
                Interface.goLiveDetail(this,{
                    id:item.source_id,
                    type:2
                })
            }else{
                Interface.goCourse(this,{
                    id:item.course_id,
                    type:2
                })
            }
        },
        // 课程详情页面跳转
        goCourseDetail(item,parent) {
            if(parent.source_type == 4){
                Interface.goLiveDetail(this,{
                    id:item.id,
                    type:1,
                    live_status:item.live_status
                })
            }else{
                Interface.goCourse(this,{
                    id:item.id,
                    type:1
                })
            }
        },
    },
    created() {
        //this.onLoad()
        Interface.getShareInfo(this,'临床好课',"","精选实用课，堂堂有收获")
    }
}
</script>

<style scoped lang="scss">
@import "./list.scss";
</style>



// WEBPACK FOOTER //
// src/views/clinic-course/list-new.vue